export class FileManagerFakeDb
{
    public static files = [
        {
            'name'     : 'Work Documents',
            'type'     : 'folder',
            'owner'    : 'me',
            'size'     : '',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true
        },
        {
            'name'     : 'Public Documents',
            'type'     : 'folder',
            'owner'    : 'public',
            'size'     : '',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true
        },
        {
            'name'     : 'Private Documents',
            'type'     : 'folder',
            'owner'    : 'me',
            'size'     : '',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true
        },
        {
            'name'     : 'Ongoing projects',
            'type'     : 'document',
            'owner'    : 'Emily Bennett',
            'size'     : '1.2 Mb',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true,
            'preview'  : 'assets/images/file-manager/sample-file-preview.jpg'
        },
        {
            'name'     : 'Shopping list',
            'type'     : 'document',
            'owner'    : 'Emily Bennett',
            'size'     : '980 Kb',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true,
            'preview'  : 'assets/images/file-manager/sample-file-preview.jpg'
        },
        {
            'name'     : 'Invoices',
            'type'     : 'spreadsheet',
            'owner'    : 'Emily Bennett',
            'size'     : '750 Kb',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true,
            'preview'  : 'assets/images/file-manager/sample-file-preview.jpg'
        },
        {
            'name'     : 'Crash logs',
            'type'     : 'document',
            'owner'    : 'Emily Bennett',
            'size'     : '980 Mb',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true,
            'preview'  : 'assets/images/file-manager/sample-file-preview.jpg'
        },
        {
            'name'     : 'System logs',
            'type'     : 'document',
            'owner'    : 'Emily Bennett',
            'size'     : '52 Kb',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true,
            'preview'  : 'assets/images/file-manager/sample-file-preview.jpg'
        },
        {
            'name'     : 'Prices',
            'type'     : 'spreadsheet',
            'owner'    : 'Emily Bennett',
            'size'     : '27 Mb',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true,
            'preview'  : 'assets/images/file-manager/sample-file-preview.jpg'
        },
        {
            'name'     : 'Anabelle Manual',
            'type'     : 'document',
            'owner'    : 'Emily Bennett',
            'size'     : '1.1 Kb',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true,
            'preview'  : 'assets/images/file-manager/sample-file-preview.jpg'
        },
        {
            'name'     : 'Steam summer sale budget',
            'type'     : 'spreadsheet',
            'owner'    : 'Emily Bennett',
            'size'     : '505 Kb',
            'modified' : 'March 8, 2025',
            'opened'   : 'March 8, 2025',
            'created'  : 'March 8, 2025',
            'extention': '',
            'location' : 'My Files > Documents',
            'offline'  : true,
            'preview'  : 'assets/images/file-manager/sample-file-preview.jpg'
        }
    ];

}